<template>
  <div class="zhanqu">
      <div class="inner" v-if="areaList && areaList.length">
        <div class="pub-title" id="q0">
          <span>{{ $t('zhanqu') }}</span>
        </div>
        <div class="content">
          <!-- <img :src="area.exhibitionBigPc" style="width: 100%; height: auto" alt=""> -->
          <el-image 
            v-for="(item, index) in areaList"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item.exhibitionBigPc" 
            :preview-src-list="[item.exhibitionBigPc]">
          </el-image>
          <!-- <img v-for="(item, index) in areaList" :key="index" :src="item.exhibitionBigPc" alt=""> -->
        </div>
      </div>
      <zgzb></zgzb>
      <waic-banner code="h5_exhibit_detail_advert" :data="banners.exhibition" v-if="banners.exhibition && banners.exhibition.length"></waic-banner>
      <div class="zhanqu1" id="q1">
        <div class="pub-title">
          <span>{{ $t('exhibitorList') }}</span>
        </div>
        <div class="imgs">
          <el-image 
            fit="fill"
            style="width: 100%; height: auto"
            src="https://static.worldaic.com.cn/2023/normal/static/images/zqml/1.png" 
            :preview-src-list="['https://static.worldaic.com.cn/2023/normal/static/images/zqml/big1.png']">
          </el-image>
          <!-- <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/1.png`" alt=""> -->
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/2.png`" alt="">
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/3.png`" alt="">
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/4.png`" alt="">
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/5.png`" alt="">
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/6.png`" alt="">
          <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/7.png`" alt="">
          <!-- <img :src="`https://static.worldaic.com.cn/2023/normal/static/images/zqml/big3.png`" alt=""> -->
          <el-image 
            fit="fill"
            style="width: 100%; height: auto"
            src="https://static.worldaic.com.cn/2023/normal/static/images/zqml/big3.png" 
            :preview-src-list="['https://static.worldaic.com.cn/2023/normal/static/images/zqml/big3.png']">
          </el-image>
        </div>
        
        <!-- <select-title :data="data" class="zhanqu-title" @params="getZq" @clickSearch="clickSearch"></select-title>
        <div class="table-line"></div>
        <div class="table-wrapper">
          <div class="table">
            <div class="table-head">
              <div>ID</div>
              <div>{{ $t('enterpriseTit') }}</div>
              <div>{{ $t('minglu1') }}</div>
              <div>{{ $t('exhibitionHall') }}</div>
              <div>{{ $t('minglu2') }}</div>
            </div>
            <ul>
              <li v-for="(subitem, subindex) in directoryList" :key="subindex" @click="modalFn(subitem)">
                <p>{{ subindex + 1 }}</p>
                <p>{{ subitem['enterpriseName' + En] }}</p>
                <p>{{ subitem['companyLevelName' + En] }}</p>
                <p>{{ subitem["exhibitionArea" + En] }}</p>
                <p>{{ subitem.boothNumber }}</p>
              </li>
            </ul>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          :page-size="7"
          :layout="pageLayout"
          :pager-count="isPc ? 7 : 3"
          :total="total">
        </el-pagination> -->
      </div>
      <zhanshangDialog
        :showModal.sync="showModal"
        :uuid.sync="uuid"
      ></zhanshangDialog>
  </div>
</template>

<script>
import protal from "@/api/protal";
import zgzb from "./zgzb.vue"
import zhanshangDialog from "@/components/zhanshangDialog.vue";

export default {
  components: {
    zgzb,
    zhanshangDialog
  },
  name: 'zhanqu',
  data() {
    return {
      tabs: ['zhanqu1', 'zhanqu2', 'zhanqu3', 'zhanqu4', 'zhanqu5', 'zhanqu6'],
      active: 0,
      search: '',
      currentPage: 0,
      pageNum: 1,
      data: [],
      total: 0,
      areaList: [],
      typeList: [],
      directoryList: [],
      area: {},
      params: {},
      showModal: false
    }
  },
  activated() {
    this.pageView('gw_zhanshanpage')
    this.getSearch();
    this.getData();
  },
  methods: {
    clickSearch(obj) {
      this.$jsAPI('track','exhibitorListFilter',
          {
            'filterType_var': obj.typeName,
            'filterName_var': obj.name
          }
      );
      gio('track','exhibitorListFilter',
          {
            'filterType_var': obj.typeName,
            'filterName_var': obj.name
          }
      );
    },
    modalFn(item) {
      this.$jsAPI('track','exhibitorContent',
          {
            'exhibitorName_var': item.enterpriseName,
            'exhibitorid_var': item.uuid,
            'exhibitortype_var': item.companyLevelName || '',
            'exhibitoraddress_var': item.exhibitionArea + ' ' + item.boothNumber
          }
      );
      this.showModal = true
      this.uuid = item.uuid
    },
    getSearch() {
      protal.queryOfficialExhibitionType().then(res => {
        this.data = res.data || []
      })
    },
    handleCurrentChange(v) {
      this.pageNum = v
        this.getZq()
    },
    async getData() {
      await protal.getZdType("exhibition_area_type").then((res) => {
        if (res && res.data && res.data.length) {
          this.typeList = res.data;
        }
      });
      // 展区导航
      protal.queryExhibitionAreaList().then((res) => {
        if (res && res.data && res.data.length) {
          this.areaList = res.data;
          this.tabClick(0, this.typeList[0].uuid);
          this.setSuccessNum()
        }
      });
      this.getZq()
    },
    getZq(obj) {
      if (obj && obj.keywords) {
        obj.keyWords = obj.keywords
        delete obj.keywords
      }
      let params = { pageNum: this.pageNum, pageSize: 7 }
      if (obj) {
        params = {...params, ...obj}
        params.pageNum = 1
        this.pageNum = 1
        this.params = JSON.parse(JSON.stringify(obj))
      } else {
        params = {...params, ...this.params}
      }
      // 展商目录
      protal.getH5MerchantList(params).then((res) => {
        this.total = res.total
        if (res && res.data && res.data.length) {
          this.directoryList = res.data;
        } else {
          this.directoryList = []
        }
      });
    },
    tabClick(index, data) {
      this.tabIndex = index;
      this.area =
        this.areaList.filter((x) => x.exhibitionType === data)[0] || {};
    },
  }
}
</script>

<style lang="less" scoped>
.imgs /deep/ .el-image-viewer__canvas {
  position: relative;

  img {
    position: absolute;
    top: 0;
    max-height: none !important;
    transform-origin: center top;
    width: 90%;
  }
}

@media screen and (min-width: 769px) {
  .zhanqu {
    padding: 1.65rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/dahui-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 15rem;
      margin: 0 auto;
    }

    .tabs {
      margin-top: .63rem;
    }

    .content {
      margin-top: .48rem;

      .el-image {
        width: 100% !important;
        height: auto !important;
      }

      img {
        display: block;
        width: 100%;
        height: auto;
        margin-bottom: .2rem;
      }
    }

    .zhanqu-title /deep/.select-search {
      margin: .61rem 0 0;
    }

    .zhanqu1 {
      width: 14.2rem;
      margin: 2.17rem auto 0;

      .imgs {
        padding-top: 1rem;
        width: 100%;

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .search {
        display: block;
        width: 14.2rem;
        margin: .61rem auto .4rem;
      }
    }

    .table {

      .table-head {
        display: flex;
        position: relative;
        height: .66rem;
        border-top: 1px solid RGBA(199, 202, 204, 1);

        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: .02rem;
          background-image: url(https://static.worldaic.com.cn/2024/web/static/images/title-line.png);
          background-size: 100% 100%;
        }

        div {
          font-size: .22rem;
          color: #595757;
          display: flex;
          align-items: center;
          font-weight: bold;
          padding-left: .14rem;

          &:nth-child(1) {
            width: 1.2rem;
            justify-content: center;
            padding-left: 0;
          }

          &:nth-child(2) {
            width: 5.52rem;
          }

          &:nth-child(3) {
            width: 2.78rem;
          }

          &:nth-child(4) {
            width: 2.9rem;
          }

          &:nth-child(5) {
            // width: 2.48rem;
            flex: 1;
            justify-content: center;
            padding-left: 0;
          }

          &:nth-child(6) {
            flex: 1;
            justify-content: center;
            padding-left: 0;
          }
        }
      }

      ul {
        li {
          display: flex;
          cursor: pointer;

          p {
            height: .66rem;
            border-bottom: 1px solid RGBA(199, 202, 204, 1);
            display: flex;
            align-items: center;
            font-size: .18rem;
            color: #595757;
            padding-left: .14rem;

            &:nth-child(1) {
              width: 1.2rem;
              justify-content: center;
              padding-left: 0;
            }

            &:nth-child(2) {
              width: 5.52rem;
            }

            &:nth-child(3) {
              width: 2.78rem;
            }

            &:nth-child(4) {
              width: 2.9rem;
            }

            &:nth-child(5) {
              // width: 2.48rem;
              flex: 1;
              justify-content: center;
              padding-left: 0;
            }

            &:nth-child(6) {
              flex: 1;
              justify-content: center;
              padding-left: 0;
            }
          }
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .zhanqu {
    width: 100%;
    padding: 1.57rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/wap-bg.jpg);
    background-size: 100% auto;

    .inner {
      width: 6.86rem;
      margin: 0 auto;
    }

    .zhanqu-title {
      margin: .47rem 0 .4rem;
    }

    .content {
      margin-top: .48rem;

      .el-image {
        width: 100% !important;
        height: auto !important;
        margin-bottom: .2rem;
      }

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    .zhanqu1 {
      width: 6.86rem;
      margin: 1.45rem auto 0;

      .imgs {
        padding-top: .5rem;
        width: 100%;

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }

    .table-line {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: .8rem;
        width: 100%;
        height: .02rem;
        background-image: url(https://static.worldaic.com.cn/2024/web/static/images/title-line.png);
        background-size: 100% 100%;
      }
    }

    .table-wrapper {
      position: relative;
      width: 100%;
      overflow-x: auto;
    }

    .table {
      width: 12rem;

      .table-head {
        display: flex;
        position: relative;
        height: .8rem;
        border-top: 1px solid RGBA(199, 202, 204, 1);

        div {
          font-size: .26rem;
          color: #595757;
          display: flex;
          align-items: center;
          font-weight: bold;
          padding-left: .26rem;

          &:nth-child(1) {
            width: .47rem;
            justify-content: center;
            padding-left: 0;
          }

          &:nth-child(2) {
            width: 4.52rem;
          }

          &:nth-child(3) {
            width: 2.28rem;
          }

          &:nth-child(4) {
            width: 2.4rem;
          }

          &:nth-child(5) {
            // width: 2.48rem;
            flex: 1;
            justify-content: center;
            padding-left: 0;
          }

          &:nth-child(6) {
            flex: 1;
            justify-content: center;
            padding-left: 0;
          }
        }
      }

      ul {
        li {
          display: flex;
          cursor: pointer;

          p {
            height: .8rem;
            border-bottom: 1px solid RGBA(199, 202, 204, 1);
            display: flex;
            align-items: center;
            font-size: .26rem;
            color: #595757;
            padding-left: .26rem;

            &:nth-child(1) {
              width: .47rem;
              justify-content: center;
              padding-left: 0;
            }

            &:nth-child(2) {
              width: 4.52rem;
            }

            &:nth-child(3) {
              width: 2.28rem;
            }

            &:nth-child(4) {
              width: 2.4rem;
            }

            &:nth-child(5) {
              // width: 2.48rem;
              flex: 1;
              justify-content: center;
              padding-left: 0;
            }

            &:nth-child(6) {
              flex: 1;
              justify-content: center;
              padding-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/zhanqu/index.vue